<template>
  <form class="form-inline search" @submit.prevent="onSubmit">
    <div class="input-group" :class="{ 'is-focused': isFocused }">
      <div class="input-group-prepend">
        <span class="input-group-text text-muted">
          <i class="fa fa-search fa-fw"></i>
        </span>
      </div>
      <input type="text" class="form-control search-field" placeholder="Search" v-model="searchText" @focus="isFocused = true" @blur="isFocused = false">
      <div class="input-group-btn">
        <button type="button" class="btn btn-link text-muted" @click.prevent="$refs.searchHelp.show">
          <i class="fa fa-question"></i>
        </button>
        <button type="button" class="btn btn-link text-muted" @click.prevent="resetSearch" v-if="searchText">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>

    <search-help ref="searchHelp"></search-help>
  </form>
</template>

<script>
import { mapState } from "vuex";

import SearchHelp from "@app/components/admin/api_requests/SearchHelp";

export default {
  props: {
    q: String
  },

  components: {
    SearchHelp
  },

  data() {
    return {
      isFocused: false,
      searchText: null
    };
  },

  methods: {
    onSubmit() {
      const q = this.searchText && this.searchText.trim();
      if (!q) return;
      this.$router.push({
        name: "apiRequestsList",
        query: {
          q: q
        }
      });
    },

    resetSearch() {
      this.searchText = null;
      this.$router.push({
        name: "apiRequestsList"
      });
    }
  },

  mounted() {
    this.searchText = this.q;
  }
};
</script>

<style scoped>
form.search {
  margin-left: 1rem;
  width: 100%;
}

@media (max-width: 575.98px) {
  form.search {
    margin-left: 0;
    margin-top: 0.5rem;
  }
}

@media (min-width: 576px) {
  form.search {
    width: 65%;
  }
}

.search input {
  background: transparent;
  border: none;
  outline: none;
  box-shadow: none;
}

.search .input-group {
  background: rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0);
  transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}

.search .input-group.is-focused {
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.search .input-group-text {
  background: transparent;
  border: none;
  padding-right: 0;
}
</style>
